module.exports = __webpack_public_path__ + "img/tag-team.fb4aef18.svg";